<template>
    <div>  
    <b-table 
        ref="messagesTable"
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected"  
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
  
</div>        
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import messagetemplates from '@/store/dispatching/messagetemplates'

export default {
    name: 'MessagesListTable',
    components: { TablePagination },
    props: {
        filter: null,
        messageType: {
            type:String,
            required: true,
            validator( value ) {
                return ['DRIVER','DRIVER_ANNOUNCEMENT'].includes(value)
          }
        }
    },
    data: function() {
        return {
            selectedItemID: null,
            perPage: 10,
            currentPage: 1,
            filteredRows: 0,
            fields: [
                { key:"order" , label: this.$t('message_template.order')},
                { key:"message" , label: this.$t('message_template.message')}
                ],
        }

    },
    computed: {
        items () { 
            if(this.$store.state.messagetemplates)
                return this.$store.state.messagetemplates.usermessageList;
            else
                return [];
        },
        totalRows() {
            if( this.filteredRows ) return this.filteredRows
            return this.items ? this.items.length : 0
        },
    },
    created() {
        if (!this.$store.state.messagetemplates) {
            this.$store.registerModule("messagetemplates" , messagetemplates);
        }
    },
    mounted() {
        this.updateMessages()
    },
    methods: {
        onRowSelected (items) {
            if(items[0]){
                this.selectedItemID = ( items[0].id == this.selectedItemID ? null : items[0].id );
            }
            this.$emit('selectItem', items[0]);        
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        },
        updateMessages() {
            this.$store.dispatch('messagetemplates/getMessageTemplates' , this.messageType )
        }
    },
    watch: {
        // Watch for vue route changes and update messages
        $route() {
            this.updateMessages()
        },
        items: async function () {
            if(this.$refs.messagesTable){
                await this.$refs.messagesTable.refresh();
                let selected = this.selectedItemID;
                if(this.selectedItemID != null){
                    let index = this.items.findIndex( (element) => element.id == this.selectedItemID);
                    if(index > -1){
                        await this.$refs.messagesTable.selectRow(index);
                        this.selectedItemID = selected;
                    }
                }
            }
        } 
    }  
}

</script>